/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    WORLD_CUP,
    KOHLI_LAMBORGINI,
    BRIAN_LARA_ERA,
    SOUND,
    Image_3D,
} from "../../assets/images";

export const TEST_DATA = [
    {
        idx: "31",
        title: "No.1 YAARIJAM ORIGINALS",
        subtitle: "No.1 YAARIJAM ORIGINALS",
        serialNo: 'Rare #/31',
        img: "https://i.ibb.co/8dGYY9c/1-Yaari.png",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5
            }
        ]
    },
    {
        idx: "32",
        title: "No.1 YAARIJAM FESTS",
        subtitle: "No.1 YAARIJAM FESTS",
        serialNo: 'Rare #/32',
        img: "https://i.ibb.co/h7kQp4Q/2-Yaari.png",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5
            }
        ]
    },
    {
        idx: "33",
        title: "No.1 YAARIJAM PADS",
        subtitle: "No.1 YAARIJAM PADS",
        serialNo: 'Rare #/33',
        img: "https://i.ibb.co/8DJ65sB/3-Yaari.png",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5
            }
        ]
    },
    {
        idx: "34",
        title: "YAARIJAM",
        subtitle: "YAARIJAM",
        serialNo: 'Rare #/34',
        img: "https://i.ibb.co/8dmSXWD/4-Yaari.png",
        tag: 'DIAMOND',
        category: 'diamond',
        price: [
            {
                type: 'fiat',
                currency: 'USD',
                locale: 'en-US',
                amount: 1500.00
            },
            {
                type: 'crypto',
                currency: 'ETH',
                amount: 0.5
            }
        ]
    },
    // {
    //     idx: "22",
    //     title: "Bermuda P24a Note",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     serialNo: 'Rare #/24a',
    //     img: "https://i.ibb.co/sqc5Cgx/Bermuda-P24a-F-0212692.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     networkType:'ethereum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ]
    // },
    // {
    //     idx: "23",
    //     title: "Bermuda P25a Note",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     serialNo: 'Rare #/25a',
    //     img: "https://i.ibb.co/4m3JrbD/Bermuda-P25a-F-0212693.jpg",
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ]
    // },
    // {
    //     idx: "24",
    //     title: "Bermuda P26a",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     serialNo: 'Rare #/26a',
    //     img: "https://i.ibb.co/8cNx6MM/Bermuda-P26a-F-0212694.jpg",
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ]
    // },
    // {
    //     idx: "25",
    //     title: "Bermuda P32b",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     serialNo: 'Rare #/32b',
    //     img: "https://i.ibb.co/MVrKqnK/Bermuda-P32b-F-0212695.jpg",
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ]
    // },
    // {
    //     idx: "26",
    //     title: "Bermuda P33c Note",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     serialNo: 'Rare #/33c',
    //     img: "https://i.ibb.co/S7qvVct/Bermuda-P33c-F-0212696.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ]
    // },
    // {
    //     idx: "27",
    //     title: "British Caribbean Terr. P-6",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     serialNo: 'Rare #/P6',
    //     img: "https://i.ibb.co/HHDs2sS/Optimized-P6-Front.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 25000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 5.29
    //         }
    //     ]
    // },
    // {
    //     idx: "28",
    //     title: "Hemakuta",
    //     subtitle: "According to Indian history, this is the hill that Lord Siva did penance before marrying a local girl Pampa.",
    //     serialNo: 'Rare #/P28',
    //     img: "https://i.ibb.co/2NPd5cR/hemakuta.jpg",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     // price: [
    //     //     {
    //     //         type: 'fiat',
    //     //         currency: 'USD',
    //     //         locale: 'en-US',
    //     //         amount: 25000
    //     //     },
    //     //     {
    //     //         type: 'crypto',
    //     //         currency: 'ETH',
    //     //         amount: 5.29
    //     //     }
    //     // ]
    // },
    // {
    //     key:"test-key",
    //     idx: "5",
    //     title: "1979 Worldcup Team",
    //     subtitle: "The 1979 Cricket World Cup was the second edition of the Cricket World Cup. Organised by the International Cricket Conference",
    //     serialNo: 'Rare #/1300',
    //     img: WORLD_CUP,
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 3000
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 1.02
    //         }
    //     ]
    // },
    // {
    //     idx: "7",
    //     title: "Brian Lara\'s Era",
    //     subtitle: "A hero, a magician, an entertainer, a match-winner, a saviour, a leader, a tragic romantic, Brian Charles Lara",
    //     serialNo: 'Rare #/1302',
    //     img: BRIAN_LARA_ERA,
    //     tag: 'GOLD',
    //     category: 'gold',
    //     networkType:'ethereum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 6000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 2.04
    //         }
    //     ]
    // },
    // {
    //     idx: "8",
    //     title: "QPCC Collections",
    //     subtitle: "The Queen’s Park Oval has been the Mecca of sport and Culture for decades, grounded in a rich history of the hosting of International Cricket, Football, Hockey, Athletics, Cycling, National Rallies, Cultural Showcases, Calypso/Soca Monarch and Beauty Queen Pageants.",
    //     serialNo: 'Rare #/1303',
    //     img: "https://i.ibb.co/kybfXnL/qpcc-collection.png",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     networkType:'polygon',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 8000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 2.72
    //         }
    //     ]
    // },
    // {
    //     idx: "9",
    //     title: "Brian Lara\'s Test Hundreds",
    //     subtitle: "Brian Charles Lara, TC, OCC, AM is a Trinidadian former international cricketer, widely acknowledged as one of the greatest batsmen of all time.",
    //     serialNo: 'Rare #/1304',
    //     img: "https://i.ibb.co/R6kZyDC/lara-hundreds.png",
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 9000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 3.10
    //         }
    //     ]
    // },
    // {
    //     idx: "10",
    //     title: "QPCC Cricket Museum",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1305',
    //     img: "https://i.ibb.co/FJ5KXYY/museum.png",
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.69
    //         }
    //     ]
    // },
    // {
    //     idx: "11",
    //     title: "QPCC Cricket Museum",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1306',
    //     img: "https://i.ibb.co/dJc6sjY/signature.png",
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.69
    //         }
    //     ]
    // },
    // {
    //     idx: "12",
    //     title: "QPCC",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1307',
    //     img: "https://i.ibb.co/cX2PD5d/sout-africa.png",
    //     tag: 'GOLD',
    //     category: 'gold',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 2000.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.69
    //         }
    //     ],
    // },
    // {
    //     idx:"6",
    //     title:"Virat Kohli\'s Lamborghini",
    //     subtitle:"A swanky Lamborghini used by Virat Kohli up for sale, and has run only 10000 km till date.",
    //     serialNo: 'Rare #/1301',
    //     img: KOHLI_LAMBORGINI,
    //     tag: 'PLATINUM',
    //     category: 'platinum',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 182766.09
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 62.04
    //         }
    //     ]
    // },
    // {
    //     idx: "1",
    //     title: "Audio Sample Product",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1800',
    //     audioDetail: true,
    //     _3dDetail: false,
    //     videoDetail: false,
    //     img: SOUND,
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5
    //         }
    //     ]
    // },
    // {
    //     idx: "491",
    //     title: "3D Sample Product",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1800',
    //     audioDetail: false,
    //     _3dDetail: true,
    //     videoDetail: false,
    //     img: Image_3D,
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5
    //         }
    //     ]
    // },
    // {
    //     idx: "492",
    //     title: "Video Sample Product",
    //     subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore ",
    //     serialNo: 'Rare #/1800',
    //     audioDetail: false,
    //     _3dDetail: false,
    //     videoDetail: true,
    //     img: "https://i.ibb.co/gM7jwmg/video-tumbnail.png",
    //     tag: 'DIAMOND',
    //     category: 'diamond',
    //     price: [
    //         {
    //             type: 'fiat',
    //             currency: 'USD',
    //             locale: 'en-US',
    //             amount: 1500.00
    //         },
    //         {
    //             type: 'crypto',
    //             currency: 'ETH',
    //             amount: 0.5
    //         }
    //     ]
    // },
];

export const FilterData = [
    {
        type: "button",
        title: "Type",
        key: "ex4",
        categories: [
            { label: "Crypto", value: "Crypto" },
            { label: "NFT", value: "NFT" },
        ],
    },
    {
        type: "button",
        title: "Country",
        key: "id-4",
        categories: [
            { label: "India", value: "Ind" },
            { label: "U.S.A.", value: "usa" },
            { label: "Canada", value: "canada" },
            { label: "Barbados", value: "barbados", disabled: true },
            { label: "Dominica", value: "dominica" },
            { label: "Jamaica", value: "jamaica" },
        ],
    },
    {
        type: "checkbox",
        title: "Categories",
        key: "id-5",
        categories: [
            { label: "Art", value: "Art" },
            { label: "Notes", value: "Notes" },
            { label: "Coins", value: "Coins" },
            { label: "Comic Books", value: "Comic Books" },
            { label: "Classic Cars", value: "Classic Cars", disabled: true },
            { label: "Stamps", value: "Stamps" },
            { label: "Jewelry", value: "Jewelry" },
            { label: "Vinyl Records", value: "Vinyl Records" },
        ],
    },
    {
        type: "checkbox",
        title: "Time period",
        key: "id-6",
        categories: [
            { label: "2001-2004", value: "2001-2004" },
            { label: "2005-2008", value: "2005-2008" },
            { label: "2009-2012", value: "2009-2012" },
            { label: "2013-2016", value: "2013-2016" },
            { label: "2017-2020", value: "2017-2020", disabled: true },
            { label: "2021", value: "2021" },
        ],
    },
    {
        type: "range",
        title: "Price",
        key: "id-9",
        min: 0,
        max: 200,
        default: "ETH",
        subCategoriesTitle: "Currency",
        categories: [
            { label: "USD", value: "USD", disabled: true },
            { label: "Ethereum", value: "ETH" },
            { label: "Indian Rupee", value: "INR" },
        ],
    },
];
